"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _UINavList = _interopRequireDefault(require("./UINavList"));

var UIFolderNav = (0, _createReactClass.default)({
  displayName: 'UIFolderNav',
  propTypes: Object.assign({}, _UINavList.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return Object.assign({}, _UINavList.default.defaultProps);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className"]);
    return _react.default.createElement(_UINavList.default, Object.assign({}, rest, {
      className: (0, _classnames.default)(className, 'private-folder-nav'),
      _rootComponent: UIFolderNav
    }), children);
  }
});
var _default = UIFolderNav;
exports.default = _default;
module.exports = exports.default;